import React, { useEffect, useState } from "react";
import {
  Input,
  Select,
  Space,
  Form,
  Button,
  notification,
  message,
  DatePicker,
  TimePicker,
  Timeline,
} from "antd";
import { AiOutlineRight } from "react-icons/ai";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import bookingRequest from "../BookingRequest";
import bookingStatusRequest from "../BookingStatusRequest";
import bookingTypeRequest from "../BookingTypeRequest";
import userRequest from "../../UserManagement/UserRequest";
import carRequest from "../../Other Master/CarRequest";
import { Option } from "antd/es/mentions";

export const AddBooking = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [bookingStatusList, setBookingStatusList] = useState([]);
  const [bookingTypeList, setBookingTypeList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [driverList, setDriverList] = useState([]);
  const [carList, setCarList] = useState([]);

  const onFinish = (values) => {
    console.log(values);
    setLoading(true);
    const allFormData = {
      ...values,
      startDate: values.startDate
        ? values.startDate.format("YYYY-MM-DD")
        : null,
      endDate: values.endDate ? values.endDate.format("YYYY-MM-DD") : null,
    };
    console.log(allFormData);
    bookingRequest
      .createBooking(allFormData)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          notification.success({
            message: "Booking added successfully",
          });
          navigate(-1);
        } else {
          notification.error({
            message: "Something went wrong",
          });
          setLoading(false);
        }
      })
      .catch((e) => {
        setLoading(false);
        notification.error({
          message: "Failed to add booking",
        });
        console.error("API Error:", e);
      });
  };

  const handleChange = (value, name) => {
    console.log(`selected ${value}`);
    if (name === "carSupplierId") {
      fetchDriverList(value);
      fetchCarList(value);
    }
  };

  const handleSubmit = () => {
    form.submit();
  };

  const fetchBookingStatusList = () => {
    setLoading(true);
    bookingStatusRequest
      .bookingStatusList()
      .then((response) => {
        const rawData = response?.data?.data || [];
        setBookingStatusList(rawData);
      })
      .catch((error) => {
        message.error("Failed to fetch booking status list");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchBookingStatusList();
  }, []);

  useEffect(() => {
    if (bookingStatusList.length > 0) {
      form.setFieldsValue({
        bookingStatusId: bookingStatusList[0].id,
      });
    }
  }, [bookingStatusList]);

  const fetchBookingTypeList = () => {
    setLoading(true);
    bookingTypeRequest
      .bookingTypeList()
      .then((response) => {
        const rawData = response?.data?.data || [];
        setBookingTypeList(rawData);
      })
      .catch((error) => {
        message.error("Failed to fetch booking type list");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchBookingTypeList();
  }, []);

  useEffect(() => {
    if (bookingTypeList.length > 0) {
      form.setFieldsValue({
        bookingTypeId: bookingTypeList[0].id,
      });
    }
  }, [bookingTypeList]);

  const fetchVendorList = () => {
    setLoading(true);
    userRequest
      .vendorList()
      .then((response) => {
        const rawData = response?.data?.data || [];
        setVendorList(rawData);
      })
      .catch((error) => {
        message.error("Failed to fetch vendor list");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchDriverList = (vendorId) => {
    setLoading(true);
    userRequest
      .driverList(vendorId)
      .then((response) => {
        const rawData = response?.data?.data || [];
        setDriverList(rawData);
      })
      .catch((error) => {
        message.error("Failed to fetch driver list");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchCarList = (ownerId) => {
    setLoading(true);
    carRequest
      .carList(ownerId)
      .then((response) => {
        const rawData = response?.data?.data || [];
        setCarList(rawData);
      })
      .catch((error) => {
        message.error("Failed to fetch car list");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchVendorList();
    fetchDriverList(0);
    fetchCarList(0);
  }, []);

  return (
    <>
      <section>
        <div className="Create-Category">
          <Form.Item className="text-center submit-btn">
            <Space>
              <Button
                className="f-sub-btn btn-width"
                onClick={() => navigate(-1)}
                disabled={loading}
              >
                <ArrowLeftOutlined />
              </Button>
            </Space>
          </Form.Item>
          <h3>Add Booking</h3>

          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            initialValues={{
              bookingStatusId:
                bookingStatusList.length > 0
                  ? bookingStatusList[0].id
                  : undefined,
            }}
          >
            <div className="subscription">
              <Form.Item
                name="indecabId"
                label="Indecab Booking Id"
                className="subscription-plan"
              >
                <Input size="large" placeholder="Enter IndecabId" />
              </Form.Item>

              <Form.Item
                name="passengerName"
                label="Passenger Name"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please enter the Passenger Name",
                  },
                ]}
              >
                <Input size="large" placeholder="Enter Passenger Name" />
              </Form.Item>

              <Form.Item
                name="passengerPhone"
                label="Passenger Phone"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please enter the Passenger Phone!",
                  },
                  {
                    pattern: /^[0-9]{10}$/,
                    message: "Phone No must be exactly 10 digits!",
                  },
                ]}
              >
                <Input size="large" placeholder="Enter Passenger Phone" />
              </Form.Item>
            </div>

            <div className="subscription">
              <Form.Item
                name="fromCity"
                label="From City"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please enter the From City",
                  },
                ]}
              >
                <Input size="large" placeholder="Enter From City" />
              </Form.Item>

              <Form.Item
                name="toCity"
                label="To City"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please enter the To City",
                  },
                ]}
              >
                <Input size="large" placeholder="Enter To City" />
              </Form.Item>
            </div>

            <div className="subscription">
              <Form.Item
                name="vehicleGroup"
                label="Vehicle Group"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please enter the Vehicle Group",
                  },
                ]}
              >
                <Input size="large" placeholder="Enter Vehicle Group" />
              </Form.Item>
              <Form.Item
                name="bookingTypeId"
                label="Duty Type"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please select the duty type!",
                  },
                ]}
              >
                <Select
                  placeholder="Select The Duty Type"
                  style={{ marginTop: "0.5rem", width: "99%" }}
                  onChange={(value) => handleChange(value, "bookingTypeId")}
                >
                  {bookingTypeList?.length > 0 &&
                    bookingTypeList.map((item, idx) => (
                      <Option key={idx} value={item?.id}>
                        {item?.typeName}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </div>
            <div className="subscription">
              <Form.Item
                name="startDate"
                label="Start Date"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please select the start date" },
                ]}
              >
                <DatePicker
                  placeholder="Select Start Date"
                  style={{ width: "99%" }}
                />
              </Form.Item>
              <Form.Item
                name="endDate"
                label="End Date"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please select the end date" },
                ]}
              >
                <DatePicker
                  placeholder="Select End Date"
                  style={{ width: "99%" }}
                />
              </Form.Item>
            </div>

            <div className="subscription">
              <Form.Item
                name="reportingTime"
                label="Reporting Time"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please select the reporting time!",
                  },
                ]}
              >
                <Input
                  type="time"
                  placeholder="Select Reporting Time"
                  style={{ width: "99%" }}
                />
              </Form.Item>

              <Form.Item
                name="estDropTime"
                label="Est. Drop Time"
                className="subscription-plan"
              >
                <Input
                  type="time"
                  placeholder="Select Est Drop Time"
                  style={{ width: "99%" }}
                />
              </Form.Item>
            </div>

            <div className="subscription">
              <Form.Item
                name="bookingPrice"
                label="Booking Price"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please enter the booking Price",
                  },
                ]}
              >
                <Input
                  type="number"
                  size="large"
                  placeholder="Enter Booking Price"
                />
              </Form.Item>

              <Form.Item
                name="supplierPrice"
                label="Supplier Price"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please enter the Supplier Price",
                  },
                ]}
              >
                <Input
                  type="number"
                  size="large"
                  placeholder="Enter Supplier Price"
                />
              </Form.Item>
            </div>

            <div className="subscription">
              <Form.Item
                name="dutyCustomerId"
                label="Duty Customer"
                className="subscription-plan"
              >
                <Select
                  placeholder="Select The Duty Customer"
                  style={{ marginTop: "0.5rem", width: "99%" }}
                  onChange={(value) => handleChange(value, "dutyCustomerId")}
                >
                  {vendorList?.length > 0 &&
                    vendorList.map((item, idx) => (
                      <Option key={idx} value={item?.id}>
                        {item?.fullName}
                      </Option>
                    ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="carSupplierId"
                label="Car Supplier"
                className="subscription-plan"
              >
                <Select
                  placeholder="Select The Car Supplier"
                  style={{ marginTop: "0.5rem", width: "99%" }}
                  onChange={(value) => handleChange(value, "carSupplierId")}
                >
                  {vendorList?.length > 0 &&
                    vendorList.map((item, idx) => (
                      <Option key={idx} value={item?.id}>
                        {item?.fullName}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </div>

            <div className="subscription">
              <Form.Item
                name="driverId"
                label="Driver"
                className="subscription-plan"
              >
                <Select
                  placeholder="Select The Driver"
                  style={{ marginTop: "0.5rem", width: "99%" }}
                  onChange={(value) => handleChange(value, "driverId")}
                >
                  {driverList?.length > 0 &&
                    driverList.map((item, idx) => (
                      <Option key={idx} value={item?.id}>
                        {item?.fullName}
                      </Option>
                    ))}
                </Select>
              </Form.Item>

              <Form.Item
                name="vehicleId"
                label="Vehicle"
                className="subscription-plan"
              >
                <Select
                  placeholder="Select The Vehicle"
                  style={{ marginTop: "0.5rem", width: "99%" }}
                  onChange={(value) => handleChange(value, "vehicleId")}
                >
                  {carList?.length > 0 &&
                    carList.map((item, idx) => (
                      <Option key={idx} value={item?.id}>
                        {item?.model}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </div>
            <div className="subscription">
              <Form.Item
                name="carSupplierCommision"
                label="Car Supplier Commision"
                className="subscription-plan"
              >
                <Input
                  type="number"
                  size="large"
                  placeholder="Enter Car Supplier Commision"
                />
              </Form.Item>
              <Form.Item
                name="bookingStatusId"
                label="Booking Status"
                className="subscription-plan"
                rules={[
                  {
                    required: true,
                    message: "Please select the booking status!",
                  },
                ]}
              >
                <Select
                  placeholder="Select The Booking Status"
                  style={{ marginTop: "0.5rem", width: "99%" }}
                  onChange={(value) => handleChange(value, "bookingStatusId")}
                >
                  {bookingStatusList?.length > 0 &&
                    bookingStatusList.map((item, idx) => (
                      <Option key={idx} value={item?.id}>
                        {item?.statusName}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </div>

            <div className="subscription">
              <Form.Item
                name="bookingAdvance"
                label="Booking Advance"
                className="subscription-plan"
              >
                <Input
                  type="number"
                  size="large"
                  placeholder="Enter Booking Advance"
                />
              </Form.Item>

              <Form.Item
                name="paymentMode"
                label="Payment Mode"
                className="subscription-plan"
                // rules={[
                //   {
                //     required: true,
                //     message: "Please select the payment mode!",
                //   },
                // ]}
              >
                <Select
                  placeholder="Select Payment Mode"
                  style={{ marginTop: "0.5rem", width: "99%" }}
                >
                  <Option value="cash">Cash</Option>
                  <Option value="credit">Credit</Option>
                </Select>
              </Form.Item>
            </div>

            <div className="subscription">
              <Form.Item
                name="appRemarks"
                label="App Remarks"
                className="subscription-plan"
              >
                <Input.TextArea size="large" placeholder="Enter App Remarks" />
              </Form.Item>

              <Form.Item
                name="bookingRemarks"
                label="Booking Remarks"
                className="subscription-plan"
              >
                <Input.TextArea
                  size="large"
                  placeholder="Enter Booking Remarks"
                />
              </Form.Item>
            </div>

            <div className="bottom-button">
              <div style={{ padding: "10px" }}>
                <Button type="primary" htmlType="submit" loading={loading}>
                  Save
                  <span>
                    <AiOutlineRight />
                  </span>
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </section>
    </>
  );
};
